export default __webpack_public_path__ + "static/Table.c44cdd20a8f703c94ce0884ba76d2ff0.svg";